import { render, staticRenderFns } from "./ConsultorSelecionado.vue?vue&type=template&id=35f45d12"
import script from "./ConsultorSelecionado.vue?vue&type=script&lang=ts"
export * from "./ConsultorSelecionado.vue?vue&type=script&lang=ts"
import style0 from "./ConsultorSelecionado.vue?vue&type=style&index=0&id=35f45d12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports